/**
 * CURATÉ homepage interactions: countdown, carousel progress, before/after, back to top
 */

(function () {
  function pad(value) {
    return String(Math.max(0, value)).padStart(2, '0');
  }

  function initCountdown() {
    document.querySelectorAll('[data-countdown-end]').forEach((bar) => {
      const endStr = bar.dataset.countdownEnd;
      if (!endStr) return;

      const endDate = new Date(endStr.replace(' ', 'T'));
      const daysEl = bar.querySelector('[data-countdown-days]');
      const hoursEl = bar.querySelector('[data-countdown-hours]');
      const minutesEl = bar.querySelector('[data-countdown-minutes]');
      const secondsEl = bar.querySelector('[data-countdown-seconds]');

      if (!daysEl) return;

      function tick() {
        const diff = endDate - Date.now();
        if (diff <= 0) {
          daysEl.textContent = '00';
          hoursEl.textContent = '00';
          minutesEl.textContent = '00';
          secondsEl.textContent = '00';
          return;
        }

        const totalSeconds = Math.floor(diff / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        daysEl.textContent = pad(days);
        hoursEl.textContent = pad(hours);
        minutesEl.textContent = pad(minutes);
        secondsEl.textContent = pad(seconds);
      }

      tick();
      setInterval(tick, 1000);
    });
  }

  function initBestsellersProgress() {
    document.querySelectorAll('[data-bestsellers-slider]').forEach((section) => {
      const slider = section.querySelector('.slider');
      const progressBar = section.querySelector('[data-progress-bar]');
      if (!slider || !progressBar) return;

      const slides = slider.querySelectorAll('.slider__slide');
      const total = slides.length;

      function updateProgress() {
        const scrollLeft = slider.scrollLeft;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        const columnsDesktop = section.querySelector('.curate-bestsellers__grid')?.className.match(/grid--(\d)-col-desktop/);
        const cols = columnsDesktop ? parseInt(columnsDesktop[1], 10) : 3;
        const pageCount = Math.max(1, total - cols + 1);
        const barWidth = 100 / pageCount;
        const progress = maxScroll > 0 ? scrollLeft / maxScroll : 0;

        progressBar.style.width = `${barWidth}%`;
        progressBar.style.marginLeft = `${progress * (100 - barWidth)}%`;
      }

      slider.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    });
  }

  function setBeforeAfterPosition(slider, value) {
    const position = Math.min(100, Math.max(0, value));
    slider.style.setProperty('--before-after-position', `${position}%`);

    const afterLayer = slider.querySelector('[data-before-after-after]');
    const handle = slider.querySelector('[data-before-after-handle]');
    const input = slider.querySelector('[data-before-after-input]');

    if (afterLayer) {
      afterLayer.style.setProperty('--before-after-position', `${position}%`);
    }
    if (handle) {
      handle.style.left = `${position}%`;
    }
    if (input) {
      input.value = position;
    }
  }

  function initBeforeAfter() {
    document.querySelectorAll('[data-before-after-slider]').forEach((slider) => {
      if (slider.dataset.beforeAfterInit === 'true') return;
      slider.dataset.beforeAfterInit = 'true';

      const input = slider.querySelector('[data-before-after-input]');
      const handle = slider.querySelector('[data-before-after-handle]');
      const initial = input ? parseInt(input.value, 10) : 50;

      setBeforeAfterPosition(slider, initial);

      input?.addEventListener('input', (event) => {
        setBeforeAfterPosition(slider, parseInt(event.target.value, 10));
      });

      if (!handle) return;

      let dragging = false;

      function updateFromPointer(clientX) {
        const rect = slider.getBoundingClientRect();
        const position = ((clientX - rect.left) / rect.width) * 100;
        setBeforeAfterPosition(slider, position);
      }

      handle.addEventListener('mousedown', () => {
        dragging = true;
      });

      handle.addEventListener('touchstart', () => {
        dragging = true;
      }, { passive: true });

      window.addEventListener('mouseup', () => {
        dragging = false;
      });

      window.addEventListener('touchend', () => {
        dragging = false;
      });

      window.addEventListener('mousemove', (event) => {
        if (!dragging) return;
        updateFromPointer(event.clientX);
      });

      window.addEventListener('touchmove', (event) => {
        if (!dragging || !event.touches[0]) return;
        updateFromPointer(event.touches[0].clientX);
      }, { passive: true });

      slider.addEventListener('click', (event) => {
        if (event.target === handle || handle.contains(event.target)) return;
        updateFromPointer(event.clientX);
      });
    });
  }

  function initAnnouncementCarousel() {
    document.querySelectorAll('[data-announcement-carousel]').forEach((carousel) => {
      if (carousel.dataset.announcementInit === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-announcement-slide]'));
      if (slides.length < 2) return;

      carousel.dataset.announcementInit = 'true';

      const prevBtn = carousel.querySelector('[data-announcement-prev]');
      const nextBtn = carousel.querySelector('[data-announcement-next]');
      const desktopQuery = window.matchMedia('(min-width: 1024px)');
      let activeIndex = slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (activeIndex < 0) activeIndex = 0;

      let autoTimer;

      function isCarouselMode() {
        return !desktopQuery.matches;
      }

      function showAllSlides() {
        slides.forEach((slide) => {
          slide.classList.add('is-active');
          slide.removeAttribute('aria-hidden');
        });
      }

      function showSlide(index) {
        if (!isCarouselMode()) {
          showAllSlides();
          return;
        }

        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }

      function resetAuto() {
        clearInterval(autoTimer);
        if (!isCarouselMode()) return;

        autoTimer = setInterval(() => {
          showSlide(activeIndex + 1);
        }, 5000);
      }

      function syncMode() {
        if (isCarouselMode()) {
          showSlide(activeIndex);
          resetAuto();
        } else {
          clearInterval(autoTimer);
          showAllSlides();
        }
      }

      prevBtn?.addEventListener('click', () => {
        if (!isCarouselMode()) return;
        showSlide(activeIndex - 1);
        resetAuto();
      });

      nextBtn?.addEventListener('click', () => {
        if (!isCarouselMode()) return;
        showSlide(activeIndex + 1);
        resetAuto();
      });

      carousel.addEventListener('mouseenter', () => {
        clearInterval(autoTimer);
      });

      carousel.addEventListener('mouseleave', resetAuto);

      desktopQuery.addEventListener('change', syncMode);
      syncMode();
    });
  }

  function initGalleryCarousel() {
    const desktopQuery = window.matchMedia('(min-width: 1200px)');
    const mobileQuery = window.matchMedia('(max-width: 767px)');

    const tabletQuery = window.matchMedia('(min-width: 768px) and (max-width: 1199px)');

    document.querySelectorAll('[data-gallery-slider]').forEach((section) => {
      if (section.dataset.galleryInit === 'true') return;
      section.dataset.galleryInit = 'true';

      const sliderComponent = section.querySelector('slider-component');
      const slider = section.querySelector('.curate-gallery__grid--carousel');
      const prevButton = section.querySelector('button[name="previous"]');
      const nextButton = section.querySelector('button[name="next"]');
      const desktopDots = Array.from(section.querySelectorAll('[data-gallery-dot]'));
      const mobileDots = Array.from(section.querySelectorAll('[data-gallery-slide-dot]'));

      if (!slider) return;

      let isDragging = false;
      let hasDragged = false;
      let dragStartX = 0;
      let dragStartY = 0;
      let dragStartScrollLeft = 0;
      let activePointerId = null;
      const dragThreshold = 8;

      function isDesktopScrollCarousel() {
        return desktopQuery.matches && sliderComponent && !slider.classList.contains('curate-gallery__grid--fit');
      }

      function isDesktopCarousel() {
        return isDesktopScrollCarousel() && desktopDots.length > 0;
      }

      function isMobileCarousel() {
        return mobileQuery.matches && sliderComponent && mobileDots.length > 0;
      }

      function isTabletCarousel() {
        return (
          tabletQuery.matches &&
          sliderComponent &&
          mobileDots.length > 0 &&
          !slider.classList.contains('curate-gallery__grid--tablet-fit')
        );
      }

      function isInteractiveCarousel() {
        return isDesktopScrollCarousel() || isMobileCarousel() || isTabletCarousel();
      }

      function getSlideMetrics() {
        const slides = Array.from(slider.querySelectorAll('.slider__slide')).filter(
          (element) => element.clientWidth > 0
        );

        if (slides.length < 2) {
          return null;
        }

        return {
          slides,
          offset: slides[1].offsetLeft - slides[0].offsetLeft,
        };
      }

      function setDotState(dots, activeIndex) {
        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      function getCenteredSlideIndex() {
        const metrics = getSlideMetrics();
        if (!metrics) return 0;

        const sliderCenter = slider.scrollLeft + slider.clientWidth / 2;
        let closestIndex = 0;
        let closestDistance = Infinity;

        metrics.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
          const distance = Math.abs(sliderCenter - slideCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      function setArrowDisabled(button, disabled) {
        if (!button) return;

        if (disabled) {
          button.setAttribute('disabled', 'disabled');
        } else {
          button.removeAttribute('disabled');
        }
      }

      function updateArrowState() {
        if (!prevButton || !nextButton || !isInteractiveCarousel()) {
          return;
        }

        const metrics = getSlideMetrics();
        if (!metrics) return;

        const { slides, offset } = metrics;
        const maxScrollLeft = Math.max(slider.scrollWidth - slider.clientWidth, 0);
        const scrollEpsilon = 4;

        if (isMobileCarousel()) {
          const activeIndex = getCenteredSlideIndex();
          setArrowDisabled(prevButton, activeIndex <= 0);
          setArrowDisabled(nextButton, activeIndex >= slides.length - 1);
          return;
        }

        const slidesPerView = isTabletCarousel() ? 3 : 4;
        const maxStartIndex = Math.max(slides.length - slidesPerView, 0);
        const currentStartIndex = Math.round(slider.scrollLeft / offset);

        setArrowDisabled(prevButton, slider.scrollLeft <= scrollEpsilon);
        setArrowDisabled(
          nextButton,
          currentStartIndex >= maxStartIndex || slider.scrollLeft >= maxScrollLeft - scrollEpsilon
        );
      }

      function scheduleGalleryUiUpdate() {
        updateDots();
        requestAnimationFrame(() => {
          requestAnimationFrame(updateArrowState);
        });
      }

      function updateDots() {
        const metrics = getSlideMetrics();
        if (!metrics) return;

        if (isDesktopCarousel()) {
          const currentPage = Math.round(slider.scrollLeft / metrics.offset) + 1;
          setDotState(desktopDots, currentPage - 1);
          return;
        }

        if (isMobileCarousel()) {
          setDotState(mobileDots, getCenteredSlideIndex());
          return;
        }

        if (isTabletCarousel()) {
          const currentIndex = Math.round(slider.scrollLeft / metrics.offset);
          setDotState(mobileDots, currentIndex);
        }
      }

      function snapToNearestSlide() {
        const metrics = getSlideMetrics();
        if (!metrics) return;

        if (isMobileCarousel()) {
          scrollToOffset(getCenteredSlideIndex());
          return;
        }

        const maxIndex = metrics.slides.length - 1;
        const targetIndex = Math.min(Math.max(Math.round(slider.scrollLeft / metrics.offset), 0), maxIndex);
        scrollToOffset(targetIndex);
      }

      function preventLinkClick(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      function blockAccidentalLinkClick() {
        slider.querySelectorAll('a.curate-gallery__link').forEach((link) => {
          link.addEventListener('click', preventLinkClick, { capture: true, once: true });
        });
      }

      function scrollToOffset(index) {
        const metrics = getSlideMetrics();
        if (!metrics) return;

        const slide = metrics.slides[index];
        if (!slide) return;

        let targetLeft = metrics.offset * index;

        if (isMobileCarousel()) {
          targetLeft = slide.offsetLeft - (slider.clientWidth - slide.clientWidth) / 2;
        }

        slider.scrollTo({
          left: targetLeft,
          behavior: 'smooth',
        });
      }

      desktopDots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          if (!isDesktopCarousel()) return;
          scrollToOffset(index);
        });
      });

      mobileDots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          if (!isMobileCarousel() && !isTabletCarousel()) return;
          scrollToOffset(index);
        });
      });

      slider.addEventListener('scroll', scheduleGalleryUiUpdate, { passive: true });
      sliderComponent?.addEventListener('slideChanged', scheduleGalleryUiUpdate);
      window.addEventListener('resize', scheduleGalleryUiUpdate);

      slider.addEventListener('pointerdown', (event) => {
        if (!isInteractiveCarousel() || event.button !== 0) return;

        isDragging = true;
        hasDragged = false;
        activePointerId = event.pointerId;
        dragStartX = event.clientX;
        dragStartY = event.clientY;
        dragStartScrollLeft = slider.scrollLeft;
      });

      slider.addEventListener(
        'pointermove',
        (event) => {
          if (!isDragging || event.pointerId !== activePointerId) return;

          const deltaX = event.clientX - dragStartX;
          const deltaY = event.clientY - dragStartY;

          if (!hasDragged) {
            if (Math.abs(deltaX) < dragThreshold && Math.abs(deltaY) < dragThreshold) {
              return;
            }

            if (Math.abs(deltaY) > Math.abs(deltaX)) {
              isDragging = false;
              activePointerId = null;
              return;
            }

            hasDragged = true;
            slider.classList.add('is-dragging');
            slider.setPointerCapture(event.pointerId);
          }

          event.preventDefault();
          slider.scrollLeft = dragStartScrollLeft - deltaX;
        },
        { passive: false }
      );

      function endDrag(event) {
        if (!isDragging || (event.pointerId !== activePointerId && event.type !== 'pointercancel')) {
          return;
        }

        const didDrag = hasDragged;
        isDragging = false;
        hasDragged = false;
        activePointerId = null;
        slider.classList.remove('is-dragging');

        if (slider.hasPointerCapture(event.pointerId)) {
          slider.releasePointerCapture(event.pointerId);
        }

        if (didDrag) {
          blockAccidentalLinkClick();
          snapToNearestSlide();
        }

        scheduleGalleryUiUpdate();
      }

      slider.addEventListener('pointerup', endDrag);
      slider.addEventListener('pointercancel', endDrag);

      desktopQuery.addEventListener('change', scheduleGalleryUiUpdate);
      mobileQuery.addEventListener('change', scheduleGalleryUiUpdate);
      tabletQuery.addEventListener('change', scheduleGalleryUiUpdate);
      scheduleGalleryUiUpdate();
    });
  }

  function initBackToTop() {
    const btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    function toggleVisibility() {
      btn.classList.toggle('is-visible', window.scrollY > 400);
    }

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function init() {
    initCountdown();
    initAnnouncementCarousel();
    initBestsellersProgress();
    initGalleryCarousel();
    initBeforeAfter();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
